import React, { lazy, Suspense, useEffect, useState } from "react";
import axios from "axios";
import Section from "@/Molecules/Section";
import { relativeRoute } from "@/helpers/relativeRoute";
import { LandingProps } from "@/types/Landing";

// leaflet needs the browser, keep it out of the server side render
const Map = lazy(() => import("@/Molecules/Map"));

/**
 * Map of the distribution area of the paper. Loaded separately because of its size, not shown when the paper has no area.
 */
const LandingDistribution = ({paper}: Pick<LandingProps, 'paper'>) => {
  const [geometry, setGeometry] = useState<object | null>(null);

  useEffect(() => {
    let cancelled = false;
    setGeometry(null);
    axios.get(relativeRoute('seo.obituary.distribution', {slug: paper.slug}))
      .then((response) => !cancelled && setGeometry(response.data || null))
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [paper.slug]);

  if (!geometry) {
    return null;
  }

  return <Section
    light
    center
    title={`Verspreidingsgebied van ${paper.title}`}
    subtitle={`In dit gebied wordt ${paper.title} verspreid.`}
  >
    <Suspense fallback={null}><Map geoJSON={geometry} mapKey={paper.slug} /></Suspense>
  </Section>;
};

export default LandingDistribution;
